import React, { useRef, useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button } from "reactstrap"
import { CSVLink } from "react-csv"

function ExcelDownload({
  headers,
  excelDownloadData,
  title,
  isLoading = false,
  onDownloadClick,
}) {
  const csvLink = useRef(null)
  const [shouldDownload, setShouldDownload] = useState(false)

  const handleDownloadClick = async () => {
    if (onDownloadClick) {
      // Call the parent's download handler to fetch data
      await onDownloadClick()
      // Set flag to trigger download on next render when data updates
      setShouldDownload(true)
    }
  }

  // Watch for when data is ready and download
  useEffect(() => {
    if (
      shouldDownload &&
      excelDownloadData &&
      excelDownloadData.length > 0 &&
      !isLoading
    ) {
      setTimeout(() => {
        if (csvLink.current) {
          csvLink.current.link.click()
        }
        setShouldDownload(false)
      }, 100)
    }
  }, [shouldDownload, excelDownloadData, isLoading])

  return (
    <>
      <Button
        data-tip
        data-for="downloadTip"
        style={{ width: "100%", border: "none" }}
        className="w-md btn mx-4 btn-warning mt-4"
        disabled={isLoading}
        onClick={handleDownloadClick}
      >
        <i
          className="bx bx-download mx-1"
          style={{
            fontSize: "18px",
            color: "white",
          }}
        />
        <span className="text-white">
          {isLoading ? "Downloading..." : "Download Excel"}
        </span>
      </Button>

      {/* Hidden CSVLink that gets triggered on click */}
      <CSVLink
        ref={csvLink}
        data={excelDownloadData || []}
        headers={headers}
        filename={`${title}.csv`}
        style={{ display: "none" }}
      />
    </>
  )
}

export default ExcelDownload

ExcelDownload.propTypes = {
  headers: PropTypes.any,
  excelDownloadData: PropTypes.any,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  onDownloadClick: PropTypes.func,
}
